 import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
 import { Injectable } from '@angular/core';
 import { async, BehaviorSubject, observable, Observable, of, throwError } from 'rxjs';
 import qnsbnurlAPI from  '../services/customer-API-URLs';
 import { AppUtils } from '../utils/app-utils';
 import { Router } from '@angular/router';
 import { QnSbnDataService } from './qn-sbn-data-service.service';


@Injectable({
  providedIn: 'root'
})
 export class QnSbnService {
   public baseUrl = `${window.location.origin}/api/`; 

   public constructor(
    public http: HttpClient, 
    public appUtil: AppUtils, 
    public _QnSbnDataService:QnSbnDataService,
    public router: Router
  ) {
    }

  public getQnSbnService(url:string): Observable<any> {
    return this.http.get(url ,{
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      });
  }

  dataToBeSaveOnS3(contactNotificationId,fileToBeUpload,notificationIdP?,isLastFile?,publicKeyToken?){
    if(fileToBeUpload){
      let filename = fileToBeUpload.name;
      let uploadUrl = '';      
      // Add publicKeyToken to URL if it exists (non-dialog user)
      if (publicKeyToken) {
        uploadUrl = this.baseUrl + qnsbnurlAPI.getNonDialogSignedURLForFileUpload + filename + "&notificationid=" + notificationIdP + "&contactnotificationid=" + contactNotificationId + "&Verify=" + false;
        uploadUrl += "&publickey=" + publicKeyToken;
      }else{
        uploadUrl = this.baseUrl + qnsbnurlAPI.getSignedURLForFileUpload + filename + "&notificationid=" + notificationIdP + "&contactnotificationid=" + contactNotificationId + "&Verify=" + false;
      }
      this.getQnSbnService(uploadUrl).subscribe(async res=>{   
        if(res){
          let uploadURL = res['body'];
          const httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/octet-stream",
              "Accept": '*/*'
            })
          };          

          this.http.put(uploadURL,fileToBeUpload,httpOptions).subscribe(d=>{
             // Build verify URL with conditional publicKeyToken
          let verifyUrl = '';      
            // Add publicKeyToken to URL if it exists (non-dialog user)
            if (publicKeyToken) {
              verifyUrl = this.baseUrl + qnsbnurlAPI.getNonDialogSignedURLForFileUpload + filename + "&notificationid=" + notificationIdP + "&contactnotificationid=" + contactNotificationId + "&Verify=" + true;
              verifyUrl += "&publickey=" + publicKeyToken;
            }else{
              verifyUrl = this.baseUrl + qnsbnurlAPI.getSignedURLForFileUpload + filename + "&notificationid=" + notificationIdP + "&contactnotificationid=" + contactNotificationId + "&Verify=" + false;
            }
            this.getQnSbnService(verifyUrl).subscribe(async res=>{
              if(res){
                if(isLastFile){
                    this.router.navigateByUrl('/main');
                } else if(isLastFile === false) {
                     this.router.navigateByUrl('/main');
                }
              }else{
               console.error("Send or Save local notification failed.");
              }
            },
            (err)=>{
            console.error("Local uploaded File size is Zero", err);
            });
          },
          (err)=>{
          console.error("Send or Save local notification failed", err);
          });
        }
      });
    }
  }

  downloadLocalAttachmentApi(filename:string, notificationId:string, contactNotifictaionId:string) {
    const apiurl = this.baseUrl + qnsbnurlAPI.downloadAttachment + "Filename="+filename+"&NotificationId="+notificationId+"&ContactNotificationId="+contactNotifictaionId;
    this.getQnSbnService(apiurl).subscribe(res=>{
      if(res){
        let downloadURL = res['body'];
        this.appUtil.fetchDoc(downloadURL,'', '', filename);
      }
    });
  }

 }